/** JS according event listener Fix */

/** 
 * Accordion & Content Spacing / Paragraph Class Fix
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Inject CSS targeting class names for precise top and bottom spacing
  const style = document.createElement('style');
  style.textContent = `
    /* Neutralize theme transform and padding/margins on inner containers */
    .collapsible-content--all .collapsible-content__inner {
      transform: none !important;
      padding-top: 0px !important;
      padding-bottom: 0px !important;
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }

    /* Outer container reset */
    [id*="FAQ-content"],
    .collapsible-content {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
      margin-top: 0px !important;
      margin-bottom: 0px !important;
    }

    /* Paragraph padding control: 7px top and 14px bottom */
    p.faq-accordion-paragraph {
      margin-top: 0px !important;
      margin-bottom: 0px !important;
      padding-top: 7px !important;    /* <--- 7px TOP PADDING */
      padding-bottom: 14px !important; /* <--- 14px BOTTOM PADDING */
    }

    /* Target inner metafield spans */
    .metafield-multi_line_text_field {
      display: block !important;
      color: #000000 !important;
      line-height: 1.4 !important;
    }
  `;
  (document.body || document.head).appendChild(style);

  // 2. Accordion Toggle Logic
  const triggers = document.querySelectorAll('.collapsible-trigger, button[aria-controls*="content"], button[aria-controls*="FAQ-content"]');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      const contentId = trigger.getAttribute('aria-controls');
      const content = contentId ? document.getElementById(contentId) : trigger.nextElementSibling;

      if (!content) return;

      const nextState = !isExpanded;
      trigger.setAttribute('aria-expanded', String(nextState));

      if (nextState) {
        // Assign class to paragraphs and clear old inline styles
        const paragraphs = content.querySelectorAll('p');
        paragraphs.forEach((p) => {
          p.classList.add('faq-accordion-paragraph');
          p.removeAttribute('style');
        });

        // Strip empty leading whitespace text nodes
        const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, null, false);
        let node;
        while ((node = walker.nextNode())) {
          if (!node.nodeValue.trim()) {
            node.nodeValue = '';
          } else {
            break;
          }
        }

        // Apply open state
        content.style.setProperty('display', 'block', 'important');
        content.style.setProperty('visibility', 'visible', 'important');
        content.style.setProperty('opacity', '1', 'important');
        content.style.setProperty('height', 'auto', 'important');
        content.style.setProperty('overflow', 'visible', 'important');

      } else {
        // Close accordion
        content.style.setProperty('height', '0px', 'important');
        content.style.setProperty('opacity', '0', 'important');
        content.style.setProperty('visibility', 'hidden', 'important');
        content.style.setProperty('display', 'none', 'important');
        content.style.setProperty('overflow', 'hidden', 'important');
      }
    }, true);
  });
});

/** Update the Yotpo Q&A button text color to white */

(function forceYotpoTextColor() {
  // 1. Create a style tag
  const style = document.createElement('style');
  style.id = 'force-yotpo-white-text';
  style.innerHTML = `
    #yotpo-widget-btn,
    #yotpo-widget-btn *,
    .yotpo-question-btn,
    .yotpo-question-btn * {
      color: #ffffff !important;
      -webkit-text-fill-color: #ffffff !important;
    }
  `;
  
  // 2. Append it to the head so it wins specificity
  document.head.appendChild(style);
})();


/** PLP/PDP Product title update from <div to <h2 for better ADA HTML structure. */

(function () {
  function convertTitlesToH2() {
    // Select all product title DIVs that haven't been converted yet
    const titleDivs = document.querySelectorAll('div.boost-sd__product-title');

    titleDivs.forEach((oldDiv) => {
      // Create the replacement <h2> element
      const h2 = document.createElement('h2');

      // Copy all attributes (class, id, data attributes, etc.) from the <div> to the <h2>
      Array.from(oldDiv.attributes).forEach((attr) => {
        h2.setAttribute(attr.name, attr.value);
      });

      // Transfer the inner content/text
      h2.innerHTML = oldDiv.innerHTML;

      // Replace the <div> with the new <h2> in the DOM
      oldDiv.parentNode.replaceChild(h2, oldDiv);
    });
  }

  // Run immediately on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertTitlesToH2);
  } else {
    convertTitlesToH2();
  }

  // Observe DOM changes (Boost updates grid dynamically on filter/sort/pagination)
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldUpdate = true;
        break;
      }
    }
    if (shouldUpdate) {
      convertTitlesToH2();
    }
  });

  // Start watching the page body for dynamic updates
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();



/**
 * Accessibility Fix: perweb–AM35 - Accessibility Remediation Patch
 * Fixes missing accessible names and unnecessary aria-live attributes 
 * on dynamically injected 3rd-party customer hub dialogs.
 */

document.addEventListener('DOMContentLoaded', () => {
  // Define the target node to observe (the whole body since the drawer is injected)
  const targetNode = document.body;

  // Configuration of the observer: watch for child elements being added
  const config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        
        // Target the specific dynamic drawer by its persistent classes
        const dialogs = document.querySelectorAll('div[role="dialog"].kl-hub-drawer');
        
        dialogs.forEach(dialog => {
          // 1. Remove the anti-pattern aria-live attribute
          if (dialog.hasAttribute('aria-live')) {
            dialog.removeAttribute('aria-live');
          }

          // 2. Fix the missing accessible name
          // If the broken aria-labelledby is present, remove it and apply a direct aria-label
          if (dialog.getAttribute('aria-labelledby') === 'P0-3' || !dialog.hasAttribute('aria-label')) {
            
            // Look for the header text dynamically in case it changes
            const headerElement = dialog.querySelector('.Drawer__DrawerHeaderContainer-sc-1cvr78k-0, h1, h2, h3, [class*="Header"]');
            const dialogName = headerElement && headerElement.textContent.trim() 
              ? headerElement.textContent.trim() 
              : 'Sign in to view your orders'; // Fallback text
            
            // Remove the broken ID reference
            dialog.removeAttribute('aria-labelledby');
            
            // Apply the descriptive label directly
            dialog.setAttribute('aria-label', dialogName);
          }
        });
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
});




/**
 * Accessibility Fix: perweb–AMP66
 */

// Example of how it translates in a JS template override
var ariaCurrentState = (data.id === activeVariantId) ? 'aria-current="true"' : '';

var swatchHTML = '<a class="boost-sd__radio-label boost-sd__radio-label--non-radius boost-sd__radio-label--hide-text" ' +
                 'href="' + data.url + '" ' +
                 'style="background:var(--' + data.value.toLowerCase().replace(/\s/g, '') + ')" ' +
                 'aria-label="Color ' + data.value + '" ' +
                 ariaCurrentState + '>' + 
                 data.value + '</a>';


/**
 * Accessibility Fix: perweb–AMP65 - Boost AI Search & Discovery - ADA Accessibility Patch
 * Fixes redundant aria-labels on checkboxes and adds group labels to parent lists.
 */

document.addEventListener("DOMContentLoaded", function() {
  
  // Function to apply accessibility fixes to Boost filters
  function fixBoostFilterAccessibility() {
    // 1. Target all filter groups
    const filterGroups = document.querySelectorAll('.boost-sd__filter-block');
    
    filterGroups.forEach(group => {
      // Find the visual title of the filter (e.g., "Product Type", "Size")
      const titleEl = group.querySelector('.boost-sd__filter-option-title');
      if (!titleEl) return;
      const filterName = titleEl.textContent.trim();
      
      // Target the UL (or parent container) wrapping the items
      const listWrapper = group.querySelector('.boost-sd__filter-option-list');
      if (listWrapper && !listWrapper.hasAttribute('aria-label')) {
        // Add the group context to the wrapper
        listWrapper.setAttribute('aria-label', filterName);
        // Ensure it has a role of group or list if not already present
        if (!listWrapper.hasAttribute('role')) {
          listWrapper.setAttribute('role', 'group'); 
        }
      }
      
      // 2. Remove the bloated aria-label from the actual checkbox buttons
      const checkboxButtons = group.querySelectorAll('button[role="checkbox"]');
      checkboxButtons.forEach(btn => {
        if (btn.hasAttribute('aria-label')) {
          // Removing the aria-label forces the SR to read the visible inner HTML 
          // (e.g., "Belts (15)"), fixing the count omission and the redundancy.
          btn.removeAttribute('aria-label');
        }
      });
    });
  }

  // Set up a MutationObserver to watch for Boost injecting/updating the DOM
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check if Boost added nodes containing our filter items
        const addedNodes = Array.from(mutation.addedNodes);
        const hasBoostFilters = addedNodes.some(node => 
          node.nodeType === 1 && 
          (node.classList.contains('boost-sd__filter-block') || node.querySelector('.boost-sd__filter-block'))
        );
        
        if (hasBoostFilters || document.querySelector('.boost-sd__filter-block')) {
          // Run the fix
          fixBoostFilterAccessibility();
        }
      }
    }
  });

  // Start observing the body for DOM changes
  observer.observe(targetNode, config);
});



/**
 * Accessibility Fix: perweb–AMP45
 */

document.addEventListener('DOMContentLoaded', function() {
    // 1. Create the ARIA live region dynamically
    const srStatus = document.createElement('div');
    srStatus.id = 'aria-live-search-status';
    srStatus.className = 'visually-hidden';
    srStatus.setAttribute('aria-live', 'polite');
    srStatus.setAttribute('role', 'status');
    document.body.appendChild(srStatus);

    let debounceTimer;

    // 2. Function to read the DOM and announce results
    const announceResults = () => {
        const wrapper = document.getElementById('boost-sd__search-widget-init-wrapper');
        const searchInput = document.getElementById('boost-sd__search-widget-init-input-0');

        if (!wrapper || !searchInput) return;

        // Check if Boost has marked the dropdown as expanded
        const isExpanded = searchInput.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            // Target links or Boost's specific product item classes as a proxy for search results
            const results = wrapper.querySelectorAll('a[href], .boost-sd__search-widget-init-product-item');
            const resultCount = results.length;

            if (resultCount > 0) {
                // Update the hidden div text; the screen reader will automatically read this change
                srStatus.textContent = `${resultCount} search suggestions available. Use up and down arrows to navigate.`;
            } else {
                srStatus.textContent = 'No search suggestions found.';
            }
        } else {
            // Clear the announcement region when the dropdown closes
            srStatus.textContent = '';
        }
    };

    // 3. Set up a MutationObserver to watch the Boost wrapper for DOM changes
    const observer = new MutationObserver((mutations) => {
        clearTimeout(debounceTimer);
        // Debounce prevents spamming the screen reader while the DOM is actively repainting
        debounceTimer = setTimeout(announceResults, 400); 
    });

    // 4. Initialize the observer once the 3rd party app mounts the wrapper
    const initObserver = setInterval(() => {
        const wrapper = document.getElementById('boost-sd__search-widget-init-wrapper');
        if (wrapper) {
            // Observe children being added/removed and CSS style/class changes
            observer.observe(wrapper, { 
                childList: true, 
                subtree: true, 
                attributes: true, 
                attributeFilter: ['style', 'class'] 
            });
            clearInterval(initObserver); // Stop checking once attached
        }
    }, 500); 
});




/**
 * ccessibility Fix: perweb–AMP44
 */


// ADA FIX: Cart Subtotal Live Region Announcer
// Creates an empty aria-live region and watches the cart subtotal for changes
document.addEventListener('DOMContentLoaded', function() {
  // 1. Create the dedicated ARIA live region (must be empty on load)
  const liveRegion = document.createElement('div');
  liveRegion.classList.add('ada-sr-only');
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');
  liveRegion.setAttribute('role', 'status');
  document.body.appendChild(liveRegion);

  let previousSubtotal = null;

  // 2. Set up a MutationObserver to watch for DOM changes securely
  const observer = new MutationObserver(function(mutations) {
    // Target the specific subtotal element generated by the app
    const subtotalElement = document.querySelector('.docapp-cart-subtotal .money');

    if (subtotalElement) {
      const currentSubtotal = subtotalElement.textContent.trim();

      // Initialize previousSubtotal on first find without announcing
      if (previousSubtotal === null) {
        previousSubtotal = currentSubtotal;
        return;
      }

      // If the subtotal has changed, update the live region to announce it
      if (currentSubtotal !== previousSubtotal) {
        liveRegion.textContent = `Subtotal updated to ${currentSubtotal}`;
        previousSubtotal = currentSubtotal;

        // Clear the text after a short delay so consecutive identical updates are read cleanly
        setTimeout(() => {
          liveRegion.textContent = '';
        }, 3000);
      }
    }
  });

  // 3. Start observing the document for dynamically injected cart updates
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});



/**
 * ccessibility Fix: perweb–AMP42 - ADA Fix for Boost AI Search & Discovery Swatches
 * Removes invalid role="img", removes rogue 'for' attributes on anchors, 
 * and strips trailing single quotes from aria-labels.
 */


document.addEventListener('DOMContentLoaded', () => {
  const fixBoostSwatchADA = (element) => {
    // 1. Remove the conflicting image role
    if (element.getAttribute('role') === 'img') {
      element.removeAttribute('role');
    }

    // 2. Remove the invalid 'for' attribute from the anchor tag
    if (element.hasAttribute('for')) {
      element.removeAttribute('for');
    }

    // 3. Clean up stray single quotes in the aria-label
    const ariaLabel = element.getAttribute('aria-label');
    if (ariaLabel && ariaLabel.endsWith("'")) {
      element.setAttribute('aria-label', ariaLabel.replace(/'$/, '').trim());
    }
  };

  // Target existing swatches on initial load
  const cleanExistingSwatches = () => {
    document.querySelectorAll('a.boost-sd__radio-label').forEach(fixBoostSwatchADA);
  };

  cleanExistingSwatches();

  // Set up a MutationObserver to handle swatches loaded dynamically via AJAX/Filtering
  const observer = new MutationObserver((mutations) => {
    let shouldClean = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        shouldClean = true;
        break;
      }
    }
    if (shouldClean) {
      cleanExistingSwatches();
    }
  });

  // Observe the main wrapper where Boost injects product grids
  const boostWrapper = document.querySelector('.boost-sd__container') || document.body;
  if (boostWrapper) {
    observer.observe(boostWrapper, {
      childList: true,
      subtree: true
    });
  }
});



/**
 * ADA Fix: perweb–AMP39 - Dynamically append aria-labels to injected slider pagination buttons
 * Targets Slick Carousel, Flickity, and Boost integration sliders.
 */


document.addEventListener('DOMContentLoaded', () => {
  const fixCarouselAccessibility = () => {
    // Target common pagination button wrappers across Impulse and Boost
    const sliderButtons = document.querySelectorAll(
      '.flickity-page-dots button, .slick-dots button, [data-section-type*="slideshow"] button'
    );

    sliderButtons.forEach((btn, index) => {
      // If the button text is just a number (e.g., "1"), or empty, give it a descriptive label
      const slideNumber = btn.textContent.trim() || (index + 1);
      
      if (!btn.hasAttribute('aria-label')) {
        btn.setAttribute('aria-label', `Go to slide ${slideNumber}`);
      }
      
      // Ensure the button type is explicitly set for screen readers
      if (!btn.hasAttribute('type')) {
        btn.setAttribute('type', 'button');
      }
    });
  };

  // Run immediately on load
  fixCarouselAccessibility();

  // Run a MutationObserver to catch sliders built lazily by Boost JS or deferred scripts
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        // Quick check to see if injected nodes contain typical slider classes
        fixCarouselAccessibility();
      }
    });
  });

  // Observe the main content area for dynamic DOM injections
  const mainContent = document.querySelector('main') || document.body;
  observer.observe(mainContent, { childList: true, subtree: true });
});





/**
 * DA Focus Order Fix perweb–AMP35 - ADA Fix for Boost Commerce Swatch "More" controls
 * Applies role="link" and contextual aria-labels dynamically.
 */

(function() {
  function fixBoostSwatchAccessibility() {
    // 1. Select all Boost swatch 'more' buttons that haven't been fixed yet
    const swatchButtons = document.querySelectorAll('button.boost-sd__product-swatch-more:not([data-a11y-fixed])');

    swatchButtons.forEach(button => {
      // 2. Traverse up to find the parent product card container
      // This looks for common Boost or Impulse theme product card wrappers
      const productCard = button.closest('[class*="product-item"]') || 
                          button.closest('.grid-product') || 
                          button.closest('.boost-sd__product-item');

      let productName = '';

      if (productCard) {
        // 3. Find the product title within that card
        const titleElement = productCard.querySelector('[class*="product-title"], .grid-product__title, .boost-sd__product-title');
        if (titleElement) {
          productName = titleElement.textContent.trim();
        }
      }

      // 4. Construct the contextual aria-label
      const ariaLabelText = productName 
        ? `Show more options for ${productName}` 
        : `Show more options for this product`;

      // 5. Update the attributes to satisfy WCAG / screen reader requirements
      button.setAttribute('role', 'link');
      button.setAttribute('aria-label', ariaLabelText);

      // (Optional but recommended) Ensure pressing 'Enter' triggers the link if focused
      button.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          button.click();
        }
      });

      // 6. Mark as fixed to prevent redundant processing
      button.setAttribute('data-a11y-fixed', 'true');
    });
  }

  // Set up a MutationObserver because Boost injects/updates these dynamically 
  // when users filter, paginate, or search.
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldRun = true;
        break;
      }
    }
    // If new nodes were injected, run the accessibility fix
    if (shouldRun) {
      // Small timeout to ensure Boost has finished rendering the inner text
      setTimeout(fixBoostSwatchAccessibility, 150); 
    }
  });

  // Start observing the body for dynamic DOM changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Run immediately on DOM load as a fallback
  document.addEventListener('DOMContentLoaded', fixBoostSwatchAccessibility);
})();




/**
 * ADA Focus Order Fix perweb–AMP32
 */

document.addEventListener('DOMContentLoaded', function() {
    
    // Function to remove tabindex from any current active slides
    const cleanSlickSlides = () => {
      const activeSlides = document.querySelectorAll('.slick-slide[tabindex="0"]');
      activeSlides.forEach(slide => {
        slide.removeAttribute('tabindex');
      });
    };

    // 1. Run initially in case sliders are already rendered
    cleanSlickSlides();

    // 2. Set up a MutationObserver to catch dynamically injected sliders (like Boost app) 
    // and catch Slick carousel slide changes.
    const observer = new MutationObserver((mutations) => {
      let shouldClean = false;
      
      for (const mutation of mutations) {
        // Check if new nodes were added (e.g., Boost Search results loading)
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          shouldClean = true;
        }
        
        // Check if an existing slick-slide was dynamically updated with tabindex="0"
        if (mutation.type === 'attributes' && mutation.attributeName === 'tabindex') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('slick-slide') && target.getAttribute('tabindex') === '0') {
            // Remove the attribute to prevent the redundant tab stop
            target.removeAttribute('tabindex');
          }
        }
      }

      if (shouldClean) {
        cleanSlickSlides();
      }
    });

    // 3. Start observing the body for changes
    observer.observe(document.body, {
      childList: true,
      attributes: true,
      subtree: true,
      attributeFilter: ['tabindex', 'class'] // Only watch for changes to these attributes for performance
    });
    
  });




/**
 * ADA Focus Order Fix perweb–AMP31 - Remove blank elements from tab sequence in Boost Recommendations
 * Target: Scopes the fix specifically to the Boost Commerce widgets using the title class.
 */


document.addEventListener('DOMContentLoaded', function() {
    
    const cleanBoostWidgetTabs = () => {
        // 1. Target the specific class you identified
        const boostTitles = document.querySelectorAll('.boost-sd__recommendation-title-text');
        
        boostTitles.forEach(title => {
            // 2. Find the parent wrapper of this specific recommendation block. 
            // We go up a few levels to ensure we capture the whole slider/grid.
            const widgetWrapper = title.closest('.boost-sd__recommendation') || title.parentElement.parentElement;
            
            if (!widgetWrapper) return;

            // 3. Find focusable elements ONLY within this specific Boost widget
            const focusableElements = widgetWrapper.querySelectorAll('a[href], [tabindex="0"], .slick-slide');
            
            focusableElements.forEach(el => {
                // Ignore the title itself and standard form controls
                if (el.classList.contains('boost-sd__recommendation-title-text') || 
                    ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON'].includes(el.tagName)) {
                    return;
                }
                
                // Determine if the element has meaningful content
                const hasText = el.textContent.trim().length > 0;
                const hasAriaLabel = el.hasAttribute('aria-label') && el.getAttribute('aria-label').trim().length > 0;
                const hasAriaLabelledBy = el.hasAttribute('aria-labelledby');
                const hasImageOrIcon = el.querySelector('img, svg, picture') !== null;
                
                // 4. If it's a blank phantom element, strip its focusability
                if (!hasText && !hasAriaLabel && !hasAriaLabelledBy && !hasImageOrIcon) {
                    el.setAttribute('tabindex', '-1');
                    el.setAttribute('aria-hidden', 'true');
                }
            });
        });
    };

    // Run initially for any elements already present
    cleanBoostWidgetTabs();

    // Set up a MutationObserver to catch the slider when Boost injects it client-side
    const targetNode = document.body;
    const config = { childList: true, subtree: true };
    let debounceTimer;

    const observerCallback = function(mutationsList, observer) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            cleanBoostWidgetTabs();
        }, 300); 
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, config);
});



/**
 * ADA Focus Order Fix perweb–AMP30 - for Boost-SD Carousels
 * Desired DOM Order: Prev Button -> Slides Track -> Next Button -> Dots
 */


document.addEventListener('DOMContentLoaded', () => {
  // 1. Initialize MutationObserver to catch async Boost elements
  const observer = new MutationObserver((mutations) => {
    
    // Find all Boost sliders that haven't been fixed yet to prevent infinite loops
    // Adjust the generic wrapper class if your specific setup differs slightly
    const sliders = document.querySelectorAll('.boost-sd__slider:not([data-ada-fixed="true"]), .boost-sd__recommendation-block:not([data-ada-fixed="true"])');

    sliders.forEach(slider => {
      // 2. Target the specific UI controls inside the slider wrapper
      const prevBtn = slider.querySelector('button[aria-label="Previous"], button.boost-sd__slider-button-prev');
      const nextBtn = slider.querySelector('button[aria-label="Next"]');
      
      // Target the container holding the actual product cards
      const track = slider.querySelector('.boost-sd__slider-list, .boost-sd__slider-wrapper'); 
      
      // Target the pagination dots
      const dots = slider.querySelector('.boost-sd__slider-pagination'); 

      // 3. If the core interactive elements exist, reorder them in the DOM
      if (prevBtn && nextBtn && track) {
        
        // Use modern DOM insertion methods to enforce the logical structure
        slider.prepend(prevBtn);      // 1. Move "Previous" to the very beginning
        prevBtn.after(track);         // 2. Ensure "Slides Track" immediately follows "Previous"
        track.after(nextBtn);         // 3. Move "Next" immediately after the "Slides Track"
        
        if (dots) {
          nextBtn.after(dots);        // 4. Move "Slider Controls (Dots)" to the very end
        }

        // Flag the element as fixed to stop the observer from re-running on it
        slider.setAttribute('data-ada-fixed', 'true');
      }
    });
  });

  // 4. Start observing the body for DOM changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});





/**
 * Accessibility Fix: perweb–AMP28 – Associate dynamic app error messages with their inputs
 * Target: Docapp Coupon Input & Email Inputs
 */


document.addEventListener('DOMContentLoaded', () => {
  // Select the main wrapper injected by the app
  const appContainer = document.querySelector('.docapp-coupon-input.docapp-in-summary');
  
  if (!appContainer) return; // Exit if the app isn't loaded on this page

  // Configuration for the observer: watch for added elements and attribute changes (like display: none to block)
  const observerConfig = { 
    childList: true, 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['style', 'class'] 
  };

  const handleAppMutations = (mutationsList, observer) => {
    // 1. Target the specific input from the ADA report
    const couponInput = appContainer.querySelector('input[name="temp-discount"]');
    
    // REPLACE '.docapp-coupon-error' WITH THE ACTUAL CLASS OF THE ERROR DIV YOU INSPECTED IN STEP 1
    const errorMessageNode = appContainer.querySelector('.docapp-coupon-error'); 

    if (couponInput && errorMessageNode) {
      // Check if the error message is actually visible to the user
      const isErrorVisible = errorMessageNode.offsetWidth > 0 || errorMessageNode.offsetHeight > 0 || errorMessageNode.style.display !== 'none';
      const hasErrorText = errorMessageNode.textContent.trim() !== '';

      if (isErrorVisible && hasErrorText) {
        // Ensure the error node has a unique ID to link to
        const errorId = errorMessageNode.id || 'docapp-error-' + Math.random().toString(36).substring(2, 9);
        if (!errorMessageNode.id) {
          errorMessageNode.id = errorId;
        }

        // Apply ADA attributes to the input
        couponInput.setAttribute('aria-describedby', errorId);
        couponInput.setAttribute('aria-invalid', 'true');
      } else {
        // Clean up attributes if the error is resolved/hidden
        couponInput.removeAttribute('aria-describedby');
        couponInput.removeAttribute('aria-invalid');
      }
    }
  };

  // Initialize and start the observer
  const appObserver = new MutationObserver(handleAppMutations);
  appObserver.observe(appContainer, observerConfig);
});




/**
 * ADA FIX: perweb–AMP25 – Ensure custom controls provide proper textual name, role, and state information
 */


document.addEventListener("DOMContentLoaded", () => {
  const fixBoostAdaLinks = () => {
    // Target Boost swatch buttons that haven't been fixed yet
    const buttons = document.querySelectorAll('button.boost-sd__product-swatch-more:not(.ada-fixed)');

    buttons.forEach(button => {
      // 1. Find the parent product card container
      const productCard = button.closest('.boost-sd__product-item, .grid-product');
      if (!productCard) return;

      // 2. Extract the product title and URL from the main product link
      const titleLink = productCard.querySelector('a.boost-sd__product-title, a.grid-product__title, a[href*="/products/"]');
      
      // Fallbacks in case the DOM structure varies slightly
      const productTitle = titleLink ? titleLink.textContent.trim() : 'this product';
      const productUrl = titleLink ? titleLink.getAttribute('href') : '#';

      // 3. Create the new, accessible native <a> element
      const anchor = document.createElement('a');
      anchor.href = productUrl;
      
      // Preserve all Boost classes for styling, plus a flag to prevent infinite loops
      anchor.className = button.className + ' ada-fixed';
      
      // 4. Set the contextual aria-label (e.g., "Show more options for Ribbed Crew Neck Tee")
      anchor.setAttribute('aria-label', `Show more options for ${productTitle}`);
      
      // Preserve the "+" inner HTML
      anchor.innerHTML = button.innerHTML;

      // 5. Replace the inaccessible button with the new anchor
      button.replaceWith(anchor);
    });
  };

  // Run immediately on page load for any server-rendered products
  fixBoostAdaLinks();

  // 6. Set up a MutationObserver to handle Boost's AJAX filtering/pagination
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        shouldRun = true;
        break;
      }
    }
    // Re-run the fix if new products were injected into the DOM
    if (shouldRun) {
      fixBoostAdaLinks();
    }
  });

  // Attach the observer to the body to watch for Boost's DOM updates
  const targetNode = document.querySelector('body');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
});




/**
 * ADA Fix: perweb–AMP23 – Ensure custom controls provide proper textual name, role, and state information
 */


document.addEventListener('DOMContentLoaded', function() {
    // Wait to ensure jQuery is loaded (Slick Carousel requires it)
    var checkJquery = setInterval(function() {
      if (typeof window.jQuery !== 'undefined') {
        clearInterval(checkJquery);
        initSlickAccessibilityFix();
      }
    }, 100);

    function initSlickAccessibilityFix() {
      var $ = window.jQuery;

      // Core function to update the ARIA attributes
      function updateSlickAccessibility(slider) {
        var $slider = $(slider);
        
        $slider.find('.slick-dots li button').each(function() {
          var $btn = $(this);
          
          // Extract the number from the button text (e.g., "1")
          var slideNum = $btn.text().replace(/\D/g, ''); 
          
          // Satisfy the "Go to slide X" requirement if missing
          if (slideNum) {
             $btn.attr('aria-label', 'Go to slide ' + slideNum);
          }
          
          // Remove aria-current from all buttons to prevent duplicates
          $btn.removeAttr('aria-current');
        });

        // Find the active slide dot and apply aria-current="true"
        $slider.find('.slick-dots li.slick-active button').attr('aria-current', 'true');
      }

      // Delegate event listeners for dynamically injected sliders
      $(document).on('init afterChange', '.slick-slider, .boost-sd__slider-container', function(event) {
        updateSlickAccessibility(event.target);
      });

      // Fallback: Fire once to catch sliders that initialized before the script ran
      setTimeout(function() {
        $('.slick-slider, .boost-sd__slider-container, .slick-initialized').each(function() {
          updateSlickAccessibility(this);
        });
      }, 1500);
    }
  });



/**
 * ADA Fix: Programmatically group visually related swatches
 * Targets elements with boost-sd classes to wrap them in a fieldset/legend
 */

(function() {
  // console.log("ADA Fix: Script Loaded");

  const applyA11yFix = () => {
    // 1. Target the specific labels from your screenshot
    const swatches = document.querySelectorAll('.boost-sd__radio-label:not(.ada-fixed)');
    
    if (swatches.length === 0) return;

    // console.log(`ADA Fix: Found ${swatches.length} swatches to fix.`);

    // 2. Identify the group. Usually, swatches are siblings in one container.
    // We target the parent of the labels.
    const container = swatches[0].parentElement;

    if (container && container.tagName !== 'FIELDSET') {
      // Create the fieldset
      const fieldset = document.createElement('fieldset');
      fieldset.setAttribute('role', 'radiogroup');
      fieldset.className = 'ada-fieldset-wrapper';
      
      // Inline styles to prevent layout shifts
      fieldset.style.border = 'none';
      fieldset.style.padding = '0';
      fieldset.style.margin = '0';

      // Create the Legend (Visible for ADA, but styled to match theme)
      const legend = document.createElement('legend');
      //legend.innerText = 'Color'; 
      //legend.className = 'variant__label'; // Using Impulse's native label class
      
      // 3. Manipulation: Move container contents into fieldset
      container.parentNode.insertBefore(fieldset, container);
      fieldset.appendChild(legend);
      fieldset.appendChild(container);

      // 4. Mark swatches as fixed
      swatches.forEach(s => s.classList.add('ada-fixed'));
      // console.log("ADA Fix: Fieldset successfully injected.");
    }
  };

  // Run on load
  window.addEventListener('load', applyA11yFix);

  // Run on mutations (for Quick View and Boost dynamic loading)
  const observer = new MutationObserver((mutations) => {
    applyA11yFix();
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
})();


/**
 * ADA AMP129 - WAIR - 3rd Party App - FIX
 */

(function fixAppAccessibility() {
  // Selector for the container holding the dots
  const dotsContainerSelector = '.wr-flex.wr-items-center.wr-gap-3';

  function enhanceDots() {
    const containers = document.querySelectorAll(dotsContainerSelector);
    
    containers.forEach(container => {
      // Add a label to the container
      if (!container.hasAttribute('role')) {
        container.setAttribute('role', 'group');
        container.setAttribute('aria-label', 'Slide controls');
      }

      const dots = container.querySelectorAll('span.wr-rounded-full');
      dots.forEach((dot, index) => {
        // Only apply if we haven't already fixed this dot
        if (!dot.hasAttribute('tabindex')) {
          dot.setAttribute('tabindex', '0');
          dot.setAttribute('role', 'button');
          dot.setAttribute('aria-label', `Go to Slide ${index + 1}`);
          
          // Determine if active based on background color class
          const isActive = dot.classList.contains('wr-bg-gray-800');
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');

          // Add keyboard event listener
          dot.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              dot.click();
            }
          });
        }
      });
    });
  }

  // Run once immediately in case it's already in the DOM
  enhanceDots();

  // Set up a MutationObserver to catch the modal if it's rendered dynamically
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        enhanceDots();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();



/**
 * ADA AMP118 fix aria-label added to product PDP images and zoom feature.
*/


document.addEventListener('DOMContentLoaded', function() {
  // Select the product slides or image wrappers
  const productImageContainers = document.querySelectorAll('.product-main-slide, .image-wrap');

  productImageContainers.forEach(function(container) {
    // Listen for keyboard events on the container
    container.addEventListener('keydown', function(event) {
      // Check if the key pressed is Enter (13) or Space (32)
      if (event.key === 'Enter' || event.key === ' ') {
        // Prevent default browser behavior (like scrolling down on Space)
        event.preventDefault(); 
        
        // Find the zoom button within this specific slide and trigger a click
        const zoomButton = this.querySelector('.js-photoswipe__zoom');
        if (zoomButton) {
          zoomButton.click();
        }
      }
    });
  });
});



/**
 * Reorders Yotpo Custom Questions DOM for Screen Readers
 * Matches Titles and Values based on their CSS Grid inline styles
 */


(function() {

    function fixYotpoReadingOrder() {
      // Find all custom question titles that haven't been processed yet
      const titles = document.querySelectorAll('.yotpo-custom-questions-title:not([data-a11y-processed])');
      
      if (titles.length === 0) return;

      // Find unique parent containers for these titles
      const containers = new Set();
      titles.forEach(title => containers.add(title.parentElement));

      containers.forEach(container => {
        // Get all titles in this specific container
        const containerTitles = Array.from(container.querySelectorAll('.yotpo-custom-questions-title:not([data-a11y-processed])'));
        
        containerTitles.forEach(title => {
          // Identify the exact row this title belongs to visually
          const rowStart = title.style.gridRowStart;
          
          if (!rowStart) return;

          // Find the corresponding value element in the same container.
          // It's the sibling element that is NOT a title, but shares the same grid-row-start.
          const valueElement = Array.from(container.children).find(sib => 
            !sib.classList.contains('yotpo-custom-questions-title') && 
            sib.style.gridRowStart === rowStart
          );

          if (valueElement) {
            // Reorder in the DOM: Append title first, then its value immediately after.
            // Because they use explicit grid-row-start styles, this will NOT break the visual layout.
            container.appendChild(title);
            container.appendChild(valueElement);
            
            // Mark as processed to prevent infinite loops with MutationObserver
            title.setAttribute('data-a11y-processed', 'true');
            valueElement.setAttribute('data-a11y-processed', 'true');
          }
        });
      });
    }

    // Set up a MutationObserver to watch for Yotpo's async loading and pagination changes
    function initYotpoObserver() {
      const observer = new MutationObserver((mutations) => {
        let shouldRun = false;
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length > 0) {
            shouldRun = true;
          }
        });

        if (shouldRun) {
          // Give Yotpo's internal scripts a brief moment to finish painting the DOM
          requestAnimationFrame(() => {
            fixYotpoReadingOrder();
          });
        }
      });

      // Start observing the body for injected Yotpo nodes
      observer.observe(document.body, { childList: true, subtree: true });
      
      // Run once immediately in case elements are already present
      fixYotpoReadingOrder();
    }

    // Initialize script on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initYotpoObserver);
    } else {
      initYotpoObserver();
    }
  })();



// Yotpo Q&A button text override Yotpo CSS and make the button text white

(function() {
    const targetNode = document.body; // Watch the body for the widget injection
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
        // Find the specific Yotpo button span
        const yotpoSpan = document.querySelector('#yotpo-widget-btn span');
        
        if (yotpoSpan) {
            // Check if it's already white to avoid infinite loops
            if (yotpoSpan.style.color !== 'white') {
                yotpoSpan.style.setProperty('color', 'white', 'important');
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
})();


// 1. Create a variable to hold the trigger element globally
window.lastModalTrigger = null;

// 2. Listen for the click on the "Learn more" button
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('#shopify-installments-cta');
  
  if (trigger) {
    // Store the button so we can find it later
    window.lastModalTrigger = trigger;
  }
});

// 3. Listen for the "Close" action
// Shopify's installments modal usually triggers a 'close' event or removes a specific class
document.addEventListener('click', function (event) {
  // Check if the clicked element is a close button or the overlay backdrop
  if (event.target.matches('.shopify-installments-modal__close') || 
      event.target.matches('.shopify-installments-modal-backdrop')) {
    
    if (window.lastModalTrigger) {
      // Return focus to the "Learn more" link
      window.lastModalTrigger.focus();
    }
  }
});


document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' && window.lastModalTrigger) {
    // Small delay to ensure the modal has finished its closing animation
    setTimeout(() => {
      window.lastModalTrigger.focus();
    }, 100);
  }
});